import React, {useState} from 'react';
import {makeStyles, Stepper, Step, StepLabel, Typography, Button} from '@material-ui/core/';
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import CitizenIdentityData from '../citizenIdentityData'
// import DatosCiudadanoRENAP from '../DatosCiudadanoRENAP'
import DatosDelCiudadanoResumen from '../datosDelCiudadanoResumen'
import DatosDelCiudadanoNuevoActualizacion from '../citizenIdentityData/EmpadronarActualizar'
// import DatosCiudadanoRENAPRechazarSolicitud from '../../RechazarSolicitudEmpadronamiento/DatosCiudadanoRENAP'
import {useStyles} from './style';

const StepperCensus = (props) => {
    // console.log(props)
    const classes = useStyles(),
    // 'Empadronar ciudadano', 'Rechazar Solicitud'
        steps =  ['Buscar ciudadano', 'Datos Ciudadano',],
        getStepContent = (step) => {
            switch (step) {
                case 0:
                    return <CitizenIdentityData cerrarDialogo={props.cerrarDialogo} 
                        fotosVieneVacio={"/assets/archivo.svg"}
                        mensajeFotosVieneVacio={"/assets/DatosUsuario.png"}
                        {...props}
                    />;
                case 1:
                    return <DatosDelCiudadanoNuevoActualizacion cerrarDialogo={props.cerrarDialogo} actualizarTabla={props.actualizarTabla} {...props} 
                        // ObtenerTotalDeSolicitudesPendientesDeRealizar={props.ObtenerTotalDeSolicitudesPendientesDeRealizar}
                        AbrirModalProcesarSolicitudExtranjero={props.AbrirModalProcesarSolicitudExtranjero} ejecutar={props.ejecutar}
                    />;
                case 2:
                    return <DatosDelCiudadanoResumen cerrarDialogo={props.cerrarDialogo} {...props} 
                        // ObtenerTotalDeSolicitudesPendientesDeRealizar={props.ObtenerTotalDeSolicitudesPendientesDeRealizar}
                    />;
                // case 3:
                    // return <DatosCiudadanoRENAPRechazarSolicitud cerrarDialogo={props.handCloseModal} />;
                // case 4:
                //  return <DatosDelCiudadanoResumen cerrarDialogo={props.cerrarDialogo} />;  
                default:
                    return 'Ocurrió un error, Vuelva a recargar la página por favor!';
            }
        };

    return (
        <div className={classes.root}>
            <Stepper className={classes.Margenes} activeStep={props.step}>
                {steps.map((label, index) => {
                    const stepProps = {};
                    if(props.rechazarSolicitud){
                        if (index === 1 || index === 2) {
                            stepProps.completed = false;
                        }
                    }
                    return (
                    <Step key={label} {...stepProps}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                    );
                })}
            </Stepper>
                {props.step === steps.length ? (
                    ''
                ) : (
                    <div>
                        {getStepContent(props.step)}
                    </div>
                )}
        </div>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(StepperCensus);